import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ErrorToastContainer, SuccessToastContainer } from "../whatsapp/function/CustomFunction";
import domain from "../reusecomponent/domain";
import Loader from "../CommerceManager/component/Loader";

const Action = () => {

  const services = useSelector((state)=>state.serviceStore.value);
  const [keywordInput, setKeywordInput] = useState("");
  const {storeCode} = useParams();
  const [loading, setLoading] = useState(false);
  const access_token = useSelector((state)=> state.Token.value);
  const [keywords, setKeywords] = useState([]);

  useEffect(()=>{
    if(keywords.length) return;
    fetchKeyword();
  },[]);


  const addKeyword = () => {
    if (!keywordInput.trim()) return;

    setKeywords((prev) => [...prev, keywordInput.trim()]);
    setKeywordInput("");
  };


  const removeKeyword = (index) => {
    setKeywords((prev) => prev.filter((_, i) => i !== index));
  };

  const fetchKeyword = async () => {
      try{
          setLoading(true);
          const myHeaders = new Headers();
          
          myHeaders.append(`Authorization`, `Bearer ${access_token}`);
  
          const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
          };
          const res = await fetch(`${domain()}/gmb/keyword/${storeCode}`, requestOptions)
          const result = await res.json();
          if(res.ok && result.status){
            if(result.data){
             setKeywords(JSON.parse(result.data));
            }
          }else{
            ErrorToastContainer(result.message);
          }
      }catch(e){
        ErrorToastContainer("Internal server problem");
      }finally{
          setLoading(false);
      }
  };


  const handleSubmit = async () => {
      try{
          setLoading(true);
  
          const myHeaders = new Headers();
          const formdata = new FormData();
          
          myHeaders.append(`Authorization`, `Bearer ${access_token}`);
          formdata.append("store_code",storeCode);
          keywords.forEach((id) => {
            formdata.append("keywords[]", id);
          });
  
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
          };
          const res = await fetch(`${domain()}/gmb/keyword_add`, requestOptions)
          const result = await res.json();
          if(res.ok && result.status){
             SuccessToastContainer(result.message);
          }else{
            ErrorToastContainer(result.message);
          }
      }catch(e){
        ErrorToastContainer("Internal server problem");
      }finally{
          setLoading(false);
      }
  };

  return (
    <div className="card p-4">
      {loading && (
        <Loader/>
      )}

      <h5 className="mb-3">Add Keyword</h5>

      {services.auto_add_keyword === 1 && (
        <div className="border rounded p-3 mb-3">
          <label className="fw-semibold">Add Keywords</label>

          <div className="d-flex mt-2">
            <input
              type="text"
              className="form-control"
              value={keywordInput}
              onChange={(e) => setKeywordInput(e.target.value)}
              placeholder="Enter keyword"
            />
            <button
              className="btn btn-primary ms-2 py-2 px-3"
              onClick={addKeyword}
            >
              Add
            </button>
          </div>

          {/* Keyword List */}
          <div className="mt-3">
            {keywords.length > 0 &&(
              keywords.map((keyword, index) => (
                <span
                  key={index}
                  className="badge bg-secondary me-2 mb-2"
                >
                  {keyword}
                  <button
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: "10px" }}
                    onClick={() => removeKeyword(index)}
                  />
                </span>
              ))
            )}
          </div>
        </div>
      )}

      <button className="btn btn-primary p-2" disabled={!services.auto_add_keyword} onClick={handleSubmit}>
        Save Keyword
      </button>
    </div>
  );
};

export default Action;